export function addAdsense() {
  const scriptAdsense = document.createElement('script');
  scriptAdsense.async = true;
  scriptAdsense.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-${process.env.GATSBY_ADSENNSE_KEY}`;
  scriptAdsense.crossOrigin = 'anonymous';

  document.head.appendChild(scriptAdsense);
}
